export default "__VITE_ASSET__BnuaMHnI__ 320w, __VITE_ASSET__LF7NUa7m__ 640w";